import { motion, useReducedMotion } from "framer-motion"
import type { BaseAnimationProps } from "./types"

interface AppearProps extends BaseAnimationProps {
  fade?: boolean
  scale?: boolean
  scaleStartingValue?: number
  scaleDuration?: number
  fadeDuration?: number
}

const Appear = ({
  children,
  style,
  fade = true,
  scale = true,
  scaleStartingValue = 0.6,
  delay = 0,
  scaleDuration = 0.5,
  fadeDuration = 0.4,
  className,
}: AppearProps) => {
  const shouldReduceMotion = useReducedMotion()

  return (
    <motion.div
      className={className}
      style={style}
      initial={{ opacity: fade ? 0 : 1, scale: scale ? scaleStartingValue : 1 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: fade ? 0 : 1, scale: scale ? scaleStartingValue : 1 }}
      transition={{
        delay: shouldReduceMotion ? 0 : delay,
        scale: {
          type: "spring",
          duration: scaleDuration,
          delay: shouldReduceMotion ? 0 : delay,
        },
        opacity: {
          duration: fadeDuration,
          delay: shouldReduceMotion ? 0 : delay,
        },
      }}
    >
      {children}
    </motion.div>
  )
}

export default Appear
